const textColor = 'rgb(51, 51, 51)'
const staticStyle = {
  box1Marg: { horizontal: 'auto', top: '0px', bottom: 'small' },
  box1Pad: { horizontal: 'medium', vertical: 'small' },
  reviewBoxContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  boxMargin: { vertical: 'small' },
  reviewBox: {
    anchorLink: {
      width: '100%',
      textAlign: 'center',
    },
    priceTag: {
      color: textColor,
      fontSize: 18,
      fontWeight: 'bold',
      lineHeight: '27px',
    },
    headerBox: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    reviewCount: {
      color: 'rgb(102, 102, 102)',
      fontSize: 14,
      lineHeight: '21px',
      marginLeft: 4,
    },
  },
  reviewArea: {
    backgroundColor: 'rgb(238, 244, 252)',
    borderRadius: '16px 16px 16px 0px',
    padding: 12,
    marginTop: 12,
    marginBottom: 11,
    minHeight: 93,
  },
  dateText: {
    color: textColor,
    fontSize: 12,
    lineHeight: 18,
    marginLeft: 6,
  },
  sideBySide: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sideBySideStarCount: {
    flexDirection: 'row',
    alignItems: 'center',
    height: '18px',
  },
  sideBySideVerifiedPurchaser: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  imageContainer: {
    maxWidth: 'auto',
    height: 100,
    width: 100,
    justifyContent: 'center',
  },
  commentBox: {
    marginTop: 9,
  },
  verifiedPurchaser: {
    backgroundColor: 'rgb(252, 126, 0)',
    borderRadius: 9,
    height: '15px',
    marginLeft: 5,
    width: '128px',
    alignItems: 'center',
    ownerText: {
      color: textColor,
      fontSize: 14,
      lineHeight: '21px',
    },
    text: {
      color: '#FFF',
      fontSize: 10,
      lineHeight: '15px',
      textAlign: 'center',
    },
  },
}

export default staticStyle
